import { createRouter, RouteRecordRaw, createWebHashHistory } from "vue-router";
import DashBoard from "@/views/Dashboard.vue";
import { acaraSchoolRoutes } from "./ACARASchool";
import { adminRoutes } from "@/router/Administrator";
import { schoolOfficerRoutes } from "@/router/SchoolOfficer";
import { schoolRoutes } from "@/router/School";
import { schoolInvitationRoutes } from "@/router/SchoolInvitation";
import { systemEventsRoutes } from "@/router/SystemEvents";
import { fundingRequestRoutes } from "@/router/FundingRequest";
import { schoolFileRoutes } from "./SchoolFile";
import { donorRoutes } from "@/router/Donor";
import { schoolOfficerPaymentRoutes } from "./SchoolOfficerPayment";
import { committeeMemberRoutes } from "./CommitteeMember";
import { reportRoutes } from "./Report";
import { accountJournalRoutes } from "./AccountJournal";
import { accountRoutes } from "./Account";
import { scheduledJobRoutes } from "./ScheduledJobs";

const routes: Array<RouteRecordRaw> = [
  { path: "/", component: DashBoard },
  ...acaraSchoolRoutes,
  ...adminRoutes,
  ...accountJournalRoutes,
  ...accountRoutes,
  ...schoolOfficerRoutes,
  ...schoolRoutes,
  ...schoolFileRoutes,
  ...schoolInvitationRoutes,
  ...systemEventsRoutes,
  ...fundingRequestRoutes,
  ...donorRoutes,
  ...committeeMemberRoutes,
  ...schoolOfficerPaymentRoutes,
  ...reportRoutes,
  ...scheduledJobRoutes,

  {
    path: "/registrationtobeconfirmed",
    component: () => import("@/views/Messages/RegistrationWillBeConfirmed.vue"),
  },

  {
    path: "/registrationconfirmed",
    component: () =>
      import("@/views/Messages/NewSchoolRegistrationMessage.vue"),
  },
  {
    path: "/schoolofficer/dashboard/:id",
    component: () => import("@/views/SchoolAdmin/SchoolAdminDashboard.vue"),
  },
  {
    path: "/schooldetails",
    component: () => import("@/views/SchoolAdmin/SchoolDetails.vue"),
  },

  {
    path: "/personaldetails/:id",
    component: () => import("@/views/SchoolAdmin/PersonalDetails.vue"),
  },

  {
    path: "/security/login",
    component: () => import("@/views/Security/Login.vue"),
  },
  {
    path: "/security/passwordreset",
    component: () => import("@/views/Security/ResetPassword.vue"),
  },
  {
    path: "/security/permissions",
    component: () => import("@/views/Security/UserPermissions.vue"),
  },
  {
    path: "/registration",
    component: () => import("@/views/Registration/Register.vue"),
  },
  {
    path: "/register/newschool/:name",
    component: () => import("@/views/Registration/RegisterSchool.vue"),
  },
  {
    path: "/register/newschoolofficer/:name",
    component: () => import("@/views/Registration/RegisterSchoolOfficer.vue"),
  },
  {
    path: "/testreport",
    component: () => import("@/views/ReportTest.vue"),
  },
];

const router = createRouter({
  routes,
  history: createWebHashHistory(),
  //To make new page scroll to top after navigation
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 };
  },
});

export default router;
